/** SLA delivery types, in display order. Keys of `clients.special_instructions_settings`. */
export const slaTypes = ['curbside', 'firstDrySpace', 'roomOfChoice', 'whiteGlove', 'Return', 'Warehouse Return'];

/** Display label for each SLA type. */
export const slaDisplays = {
    curbside: 'Curbside',
    firstDrySpace: 'First Dry Space',
    roomOfChoice: 'Room of Choice',
    whiteGlove: 'White Glove',
    Return: 'Return',
    'Warehouse Return': 'Warehouse Return',
};
